import { Button, Form, Modal, Select } from "antd";

const CreateCampaignTriggerModal = ({
  mailingLists = [],
  senderEmailOptions = [],
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleTriggerCreation = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleTriggerCreation(values);
  };

  return (
    <Modal
      title="Create Trigger"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        name="create_bulk_mailing_campaign_trigger_form"
        onFinish={handleFormSubmit}
      >
        <Form.Item
          name="mailingListId"
          label="Mailing List"
          rules={[
            {
              required: true,
              message: "Please select a mailing list!"
            }
          ]}
        >
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {(mailingLists || []).map((mailingList) => (
              <Select.Option value={mailingList.value} key={mailingList.value}>
                {mailingList.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="senderId"
          label="Sender"
          rules={[
            {
              required: true,
              message: "Please select a sender!"
            }
          ]}
        >
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {(senderEmailOptions || []).map((senderEmailOption) => (
              <Select.Option value={senderEmailOption.value} key={senderEmailOption.value}>
                {senderEmailOption.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateCampaignTriggerModal;
